/**
 * @generated SignedSource<<51f65d881c39867bdc9fdb46446f23de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectTemplateModal_tenant$data = {
  readonly emailTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly message: string;
        readonly name: string;
        readonly replyTo: string;
        readonly subject: string;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "SelectTemplateModal_tenant";
};
export type SelectTemplateModal_tenant$key = {
  readonly " $data"?: SelectTemplateModal_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectTemplateModal_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectTemplateModal_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplateConnection",
      "kind": "LinkedField",
      "name": "emailTemplates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailTemplateNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "replyTo",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subject",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "c0ad0725091739d1e697e43087bc40ac";

export default node;
